var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 12a10 10 0 1 0-11.56 9.87v-7H7.88V12h2.53V9.78a3.53 3.53 0 0 1 3.78-3.88 15.91 15.91 0 0 1 2.24.19v2.46h-1.26a1.44 1.44 0 0 0-1.63 1.56V12h2.77l-.44 2.88h-2.33v7A10 10 0 0 0 22 12Z"
})));
export default SvgFacebook;